import { render, staticRenderFns } from "./SenderMessage.vue?vue&type=template&id=7496d288&"
import script from "./SenderMessage.vue?vue&type=script&lang=js&"
export * from "./SenderMessage.vue?vue&type=script&lang=js&"
import style0 from "./SenderMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports